/* eslint-disable */
export default {
  Inbound: 'Entrant',
  Outbound: 'Sortants',
  log: 'Journal',
  save: 'Enregistrer et nouveau',
  discard: 'Annuler et nouveau',
  hangup: 'Raccrocher',
  reject: 'À la messagerie vocale',
  saveDraftAndCreateNewLog:
    'Enregistrer le brouillon et créer un nouveau journal des appels',
} as const;

// @key: @#@"Inbound"@#@ @source: @#@"Inbound"@#@
// @key: @#@"Outbound"@#@ @source: @#@"Outbound"@#@
// @key: @#@"log"@#@ @source: @#@"Log"@#@
// @key: @#@"save"@#@ @source: @#@"Save and new"@#@
// @key: @#@"discard"@#@ @source: @#@"Discard and new"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hangup"@#@
// @key: @#@"reject"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"saveDraftAndCreateNewLog"@#@ @source: @#@"Save draft and create new call log"@#@
